import SecurityPage from './SecurityPage';

const exports = {
    Security: { Page: SecurityPage },
};
export default exports;
